import { Circle, Tooltip } from '@chakra-ui/react';
import { ComponentType } from 'react';
import { IconProps } from '~components/ui/icons/types';

export interface Props {
  bg?: string;
  color?: string;
  icon: ComponentType<IconProps>;
  tooltip?: string;
  paddingEnabled?: boolean;
}

export function UsageIconBadge({ bg, color, icon: Icon, paddingEnabled = true, tooltip }: Props) {
  const padding = paddingEnabled ? 1.5 : 0;
  const size = paddingEnabled ? 5 : 8;
  return (
    <Tooltip label={tooltip} hasArrow>
      <Circle padding={padding} bg={bg} color={color}>
        <Icon width={size} height={size} />
      </Circle>
    </Tooltip>
  );
}
